import { render, staticRenderFns } from "./UnknownPage.vue?vue&type=template&id=7da95a31&"
import script from "./UnknownPage.vue?vue&type=script&lang=js&"
export * from "./UnknownPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports